import { createRoot } from "react-dom/client";
import React from "react";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App.js";
import HttpsRedirect from 'react-https-redirect';

Sentry.init({
  dsn: "https://dce303d162034f34b113fe662641d7ba@o4505209817268224.ingest.sentry.io/4505209818316800",
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<HttpsRedirect>
  <App />
</HttpsRedirect>)

